import { Component } from '@angular/core';

interface PartnerItem {
  readonly name: string;
  readonly logoPath: string;
  readonly logoAlt: string;
  readonly url?: string;
}

@Component({
  selector: 'app-partners',
  standalone: true,
  imports: [],
  templateUrl: './partners.html',
  styleUrl: './partners.scss',
})
export class Partners {
  readonly partnerIconPath = '/icons/handshake.svg';

  readonly partners: readonly PartnerItem[] = [
    {
      name: 'IISc',
      logoPath: '/partner-logo/IISc_Master_Seal 1.svg',
      logoAlt: 'Indian Institute of Science logo',
    },
    {
      name: 'ICMR NIE',
      logoPath: '/partner-logo/icmr 2.svg',
      logoAlt: 'ICMR National Institute of Epidemiology logo',
      url: 'https://adarv.in/',
    },
    {
      name: 'CBR IISc',
      logoPath: '/partner-logo/cbr_iisc_logo 1.svg',
      logoAlt: 'Centre for Brain Research IISc logo',
    },
  ];
}
